<template>
  <div v-if="!isAuthInCurrentRegion">
    <div class="mt-4" v-if="!authShow && this.regionChoosed">
      <b-alert class="mt-4" show variant="secondary">{{
        $t(`authorization_statement_${service}`)
      }}</b-alert>
      <b-button size="lg" variant="primary" @click="openAuth">{{
        $t("auth_iframe_block")
      }}</b-button>
    </div>

    <div class="wrap" v-if="authShow">
      <b-spinner
        class="mt-4"
        v-if="!authLoaded"
        type="grow"
        :label="$t('loading')"
      ></b-spinner>
      <iframe
        id="auth_modal"
        @load="authLoaded = true"
        v-show="authLoaded"
        class="frame"
        :src="authFrameLink"
        height="100%"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: ['source', 'service'],
  data: () => {
    return {
      authShow: false,
      authLoaded: false,
    }
  },
  computed: {
    regionChoosed() {
      return this.$root.$data.state.choosedRegion
    },
    isAuthInCurrentRegion() {
      return (
        this.regionChoosed
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp > Date.now()
      )
    },
    // isAuthInCurrentRegion() {
    //   return (
    //     this.regionChoosed
    //     && this.$root.$data.state.auth[this.regionChoosed.code]
    //     && this.$root.$data.state.auth[this.regionChoosed.code].token
    //     && this.$root.$data.state.auth[this.regionChoosed.code]
    //       .expTokenJsTimestamp > Date.now()
    //   )
    // },
    authFrameLink() {
      return `https://ru.iridi.com/auth?source=${this.source}&lang=${this.$i18n.locale}`
      // return this.$root.$data.state.choosedRegion
      //   ? `${this.$root.$data.state.choosedRegion.hosts.auth}/auth?source=${this.source}&lang=${this.$i18n.locale}`
      //   : null
    },
  },
  methods: {
    checkAuth() {
      const region = this.$root.$data.state.choosedRegion
      if (!region) {
        return
      }

      this.loading = true
      // let authObject = this.$root.$data.state.auth[region.code]
      let authObject = this.$root.$data.state.auth
      if (!authObject) {
        // authObject = localStorage.getItem(`auth_${region.code}`)

        authObject = localStorage.getItem('cross_region_auth')
        if (authObject) {
          authObject = JSON.parse(authObject)
        }
      }

      if (!authObject) {
        this.$emit('authorized', false)
        this.needAuth = true
        return
      }

      if (
        authObject
        && authObject.expTokenJsTimestamp
        && authObject.expTokenJsTimestamp > Date.now()
      ) {
        // this.$root.$data.setAuth(region.code, authObject)
        this.$root.$data.setAuth(authObject)
        this.needAuth = false
      } else {
        this.needAuth = true
      }

      this.loading = false
    },
    openAuth() {
      if (!this.$root.$data.state.choosedRegion) {
        this.$root.$data.toggleRegionSelection()
        return
      }
      this.authShow = true
      this.authLoaded = false

      window.addEventListener('message', (e) => {
        if (e.origin !== document.location.origin) {
          try {
            const postMessageData = JSON.parse(e.data)
            switch (postMessageData.act) {
              case 'success_auth':
                this.authShow = false

                // this.$root.$data.setAuth(
                //   this.$root.$data.state.choosedRegion.code,
                //   { ...postMessageData.token },
                // )
                this.$root.$data.setAuth({ ...postMessageData.token })

                // localStorage.setItem(
                //   `auth_${this.$root.$data.state.choosedRegion.code}`,
                //   JSON.stringify({ ...postMessageData.token }),
                // )

                localStorage.setItem(
                  'cross_region_auth',
                  JSON.stringify({ ...postMessageData.token }),
                )
                this.checkAuth()

                break

              default:
                break
            }
          } catch (error) {
            console.error('error', error)
          }
        }
      })
    },
  },
  mounted() {
    this.checkAuth()
  },
}
</script>

<style lang="scss">
.frame {
  border: none;
  width: 100%;
  height: 100%;
  outline: none;
  min-height: 100vh;
}
.wrap {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.auth_modal {
  .modal-body {
    padding: 0.1rem;
  }
}
</style>
